module.exports = __webpack_public_path__ + "static/BrandonGrotesque-Bold-864344bba317d344ab36a5f35293ae9a.ttf";